import {i18n} from "../../../vue-i18n";

export default class AddLessor {
  constructor(newLessorComponentShares, newPaymentParameters, newPaymentsRates, eventDate) {
    this.commandName = 'AddLessor';
    this.newLessorComponentShares = newLessorComponentShares;
    this.newPaymentParameters = newPaymentParameters;
    this.newPaymentsRates = newPaymentsRates;
    this.eventDate = eventDate;

    this.description = `${i18n.t('CONTENT.events.AddLessor')}`;
  }

  // Use this method to push this command to the server
  serialize() {
    const serialisedCommand = JSON.stringify({
      newLessorComponentShares: this.newLessorComponentShares,
      newPaymentParameters: this.newPaymentParameters,
      newPaymentsRates: this.newPaymentsRates,
    });

    return {
      commandName: this.commandName,
      serialisedCommand,
    };
  }

  equal() {
    // will always return false so user can add multiple payments
    return false;
  }
}
